import * as Yup from 'yup';

export const initialValues = (formik, item) => {
  if(!formik) return;

  let myId = 0;
  if (item != null && (Object.keys(item).length > 0 || item.constructor !== Object)) {
    myId = item.id;
  }

  formik.setFieldValue('id', myId);
};

export const validationSchema = (item) => {
  let schema = Yup.object();

  // schema = schema.shape({
  //   email: Yup.string()
  //     .test('optional-email', 'Invalid email format', (value) => {
  //       if (!value || value.length <= 5) return true; // Skip validation
  //       const isValid = Yup.string().email().isValidSync(value); // Check email format
  //       return isValid;
  //     })
  // });

  return schema;
};

export const handleSubmitted = async (
  values,
  assignCar,
  assignGroup,
  blockAccount,
  apiUpdate
) => {
  // TODO check if values.id is zero
  if(values.isVerified){
    await blockAccount(values);
  }else{
    let isSkip = false;
    let obj = values.field_groups;
    if (obj && Object.keys(obj).length > 0) {
      // Assign account to group
      await assignGroup({accountId: values.id, groupId: obj.value});
      isSkip = true;
    }
    obj = values.field_cars;
    if (obj && Object.keys(obj).length > 0) {
      // Assign car to account
      await assignCar({accountId: values.id, carId: obj.value});
      isSkip = true;
    }
    if(isSkip) return;
    values.accountId = values.id;
    await apiUpdate(values);
  }
};
